// eslint-disable-next-line no-unused-vars
import React from 'react'
import { withRouter } from 'router'

const EmptyLayout = ({ children }) => {
  return <div className="empty-layout">{children}</div>
}

export default withRouter(EmptyLayout)
